'use es6';

import keyMirror from 'react-utils/keyMirror';
export const FIELD_TYPES = keyMirror({
  dealname: null,
  dealstage: null,
  hs_is_closed: null,
  amount_in_home_currency: null,
  closedate: null,
  hs_manual_forecast_category: null
});
export const FIELD_TYPES_PROPS = {
  [FIELD_TYPES.dealname]: {
    statusProperty: 'hs_created_in_period'
  },
  [FIELD_TYPES.dealstage]: {
    statusProperty: 'hs_deal_stage_progress',
    excludedStatuses: ['NEW']
  },
  [FIELD_TYPES.hs_is_closed]: {},
  [FIELD_TYPES.amount_in_home_currency]: {
    statusProperty: 'hs_amount_change_event',
    differenceProperty: 'hs_amount_change_percentage'
  },
  [FIELD_TYPES.closedate]: {
    statusProperty: 'hs_close_date_progress'
  },
  [FIELD_TYPES.hs_manual_forecast_category]: {
    statusProperty: 'hs_manual_category_progress'
  }
};
export const getFieldTypeProps = field => {
  return FIELD_TYPES_PROPS[field];
};